((w,d,$) => {

  w.load['document.ready'] = new $.Deferred
  w.load['window.load'] = new $.Deferred
  const content_info = {
    'news': {content: 'news', module: 'content4'}
  }
  // Newマークを表示する判定
  const is_new = (date,d) => {
    return ( new Date() - (1000*60*60*24*d) <= date )? true : false
  }

  const news_block_init = (cats,items) => {
    $('[data-plugin=news-catelist]').each((i,obj) => {
      if(cats.length <= 0) obj.remove()
      const $list = $(obj).empty()
      // 「すべて」を追加
      cats.unshift({id:0,name:'ALL'})
      // カテゴリデータ整形
      cats = cats.map(cat => {
        cat.href = (cat.id!=0)? '/news/?mode=list&cat='+cat.id : '/news/'
        return cat
      })
      $.each(cats,(i,cat) => {
        $(`<a href="${cat.href}" class="button button-border">${cat.name}</a>`)
        .appendTo($list)
      })
    })
    $('[data-plugin="news-list"]').each((i,obj) => {
      const $list = $(obj).empty(),
            opt = $.extend(true,{
              newDuration : 14,
              amout : 3,
              prefix: 'p-block-news__',
              btnClass: 'button'
            },obj.dataset)
      // 記事データ整形
      items = items.map(item => {
        // カテゴリIDをオブジェクトに変換
        item.category = cats.filter(cat => cat.id == item.category).shift()
        if(!item.category) item.category = {}
        // NEWマーク判定
        item.is_new = is_new(item.date*1000,opt.newDuration)
        // 日付表記変換
        const d = new Date(item.date*1000),
              mm = ('0'+ (d.getMonth()+1) ).slice(-2),
              dd = ('0'+ d.getDate() ).slice(-2)
        item.date = `${d.getFullYear()}年${mm}月${dd}日`
        return item
      })
      // 記事ごとのループ
      $.each(items.splice(0,opt.amount),(i,item) => {
        const $catelink = $(`
                <button href="${item.category.href}" >${item.category.name}</button>
              `).attr({class:opt.btnClass,role:"catlink"}),
              $new = $('<span class="new">NEW</span>'),
              $item = $(`
                <a href="${item.href}" class="${opt.prefix}item">
                  <div class="${opt.prefix}item-head" role="itemhead">
                    <p class="date">${item.date}</p>
                  </div>
                  <div class="${opt.prefix}item-body">
                    <h4 class="title" role="title">${item.title}</h4>
                  </div>
                </a>
                <!-- /.${opt.prefix}item -->
              `).appendTo($list)
        if(item.category.id != undefined) $item.find('[role=itemhead]').append($catelink)
        if(item.is_new) $item.find('[role=title]').append($new)
        $catelink.on('click',(e)=> { location.href = e.target.attributes.href.value; return false})
      })
    })
  } // end news_block_init
  $.when(
    $.getCategory(content_info['news']),
    $.getArticle(content_info['news']),
    w.load['document.ready']
  ).done(news_block_init)

  /*****
   * googlemap実行
   */
  $.when(
    $.get('/asset/json/mapstyle.json'),
    w.load.mapScript
  ).done(mapstyle => {
    const $container = $('<div class="p-map" />'),
          $mapobj = $('<div class="p-map__googlemap" data-plugin="googlemap" />').appendTo($container),
          $mapbtn = $('<a class="button button-border-primary">Google mapで見る<em class="fa fa-lg fa-angle-right">&nbsp;</em></a>').appendTo($container)
    $mapbtn.attr({'href':'https://goo.gl/maps/DPSwaBDu7s32','target':'_blank'})
    $mapobj.data({
      title: 'スマートアグリカルチャー磐田',
      latlng: '34.7466249,137.8415309',
      address: '静岡県磐田市高見丘219-1',
      zoom:10,
      icon:'/asset/img/home/map_peg@2x.png',
      iconSize:'105,115'
    })
    $container.insertAfter('#allbox .containerWrap,.homeContents')

    if( w.google == undefined ) return false;
    if( $('[data-plugin="googlemap"]').length > 0 ){
      const $map = $('[data-plugin="googlemap"]'),
            styleObj = { name:'mapstyle', style:mapstyle[0]};
      $map.googlemap({styleObj});
    }
  });

  /*****
   * Slick実行
   */
  $.when(
    w.load['window.ready']
  ).done(() => {
    $('[data-plugin="slider"]').slick({
      autoplay:true,
      fade: true,
      dots: true,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: true
    })
  })

  $(() => w.load['document.ready'].resolve() )
  $(w).on('load',() => w.load['window.load'].resolve() )

})(window,document,jQuery);